import { ExpandedVisualType } from 'components/pages/Gallery/_main/ClientGallery/ClientGalleryPhoto'
import { useClientPhotoStudio } from '../ClientPhotoStudio.context'

/**
 * Props of the Lab SDK engine's Before | Compare | After switch for the views outside UnifiedPreview (the Adjust tool,
 * whose switch lives in Pintura's toolbar). Same shared state as UnifiedPreview: `isLabCompare` in the context.
 */
export const useLabViewSwitcherProps = () => {
  const { expandedVisualType, setExpandedVisualType, isLabCompare, setIsLabCompare } = useClientPhotoStudio()
  return {
    showCompare: true,
    expandedVisualType,
    isCompareActive: isLabCompare,
    switchExpandedVisualType: (type: ExpandedVisualType) => {
      setIsLabCompare(false)
      setExpandedVisualType(type)
    },
    onCompare: () => {
      setExpandedVisualType(ExpandedVisualType.EDITED)
      setIsLabCompare(true)
    },
  }
}
